<template>
  <div>
    <div class="parent mouse-cursor-gradient-tracking">
      <div>
        <div class="py-6 pl-12 vx-row" id="myHeader" style="z-index: 99999">
          <div class="vx">
            <a href="/user/dashboard"
              ><img
                class="mb"
                alt="logo"
                src="@/assets/images/logo/getboarded-logo.svg"
            /></a>
          </div>
          <!-- <div class="vx-col lg:w-1/12">
            <span class="material-icons">drag_handle</span>
          </div> -->
        </div>

        <div class="p-8 nav-login">
          <div class="gtb-color" id="sign-in">
            <a
              v-if="!isUserLoggedIn"
              style="color: white"
              :href="`${constants.apiHost}/oauth`"
              >Sign In</a
            >
            <div v-else>
              <!-- <ProfileDropDown /> -->
              <vs-button class="p-1 gtb-color" to="/user/dashboard"
                >My Dashboard</vs-button
              >
            </div>
          </div>
        </div>

        <aside class="secondary-menu-wrapper light-theme">
          <div class="row expanded" style="padding-left: 40px">
            <div
              class="xxlarge-2 columns"
              style="display: flex; position: relative"
            >
              <div
                class="secondary-items"
                style="display: flex; position: relative"
              >
                <span
                  class="for-wrapper"
                  style="display: inline-flex; align-items: flex-start"
                >
                  <span class="for paragraph-small mr-2"> For </span>
                </span>
                <ul style="flex-direction: column; display: inline-flex">
                  <li class="paragraph-small org mb-2" data-target="third">
                    Individuals
                  </li>
                  <li class="paragraph-small ind mb-2" data-target="third">
                    Organizations
                  </li>
                  <li class="paragraph-small evr" data-target="third">
                    Everyone
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </aside>
      </div>
      <section class="panel first">
        <div class="flex flex-wrap w-full margin-fix">
          <div class="w-full md:w-1/2 p-3">
            <div
              class="p-2 home-content"
              style="display: flex; justify: center; align-items: center"
            >
              <div class="vx-col lg:w-full" style="display: flex"></div>
              <div class="vx-col">
                <h2 class="title mb-3" style="text-align: left">
                  Create a <span style="color: #5585ff">Profile</span><br />
                  to <span style="color: #f2c244"> Discover </span>
                  <span
                    class="typewrite"
                    style="font-family: 'Dancing Script', cursive"
                    data-period="2000"
                    data-type='[ "Yourself", "Career Paths", "Suitable Opportunities ", "Relevant Learning", "Personal Coaches" ]'
                  >
                    <span class="wrap"></span>
                  </span>
                  <!-- <span style="color: #f2c244"> YOURSELF</span> -->
                </h2>
                <p class="description" style="text-align: left">
                  Build your career profiles with GetBoarded. It works not just
                  on the knowledge, but also on personality-based transferable
                  skills in today’s ever-changing career and jobs landscape.
                </p>
              </div>
            </div>
          </div>
          <div class="vx-col sm:w-full md:w-1/2 z-index-9999">
            <!-- <lets-login /> -->
            <img
              data-v-7aedf0b4=""
              width="100%"
              :src="require('@/assets/images/pages/home/img-ind.png')"
              alt=""
              style="z-index: 99999; margin: -30px 0px"
            />
          </div>
        </div>
      </section>
      <!-- first section ends -->

      <!-- second section starts -->
      <section
        class="panel third mouse-cursor-gradient-tracking"
        data-intersect-target="third"
      >
        <div class="bg-individual">
          <div class="flex flex-wrap w-full margin-fix">
            <div class="w-full md:w-1/2 p-3">
              <div
                class="p-2 home-content d-flex justify-center"
                style="display: flex; justify: center; align-items: center"
              >
                <div class="vx-col lg:w-full" style="display: flex"></div>
                <div class="vx-col">
                  <h2 class="title mb-3">
                    Create an <span style="color: #5585ff">Organization</span
                    ><br />
                    to
                    <span
                      class="typewrite"
                      style="font-family: 'Dancing Script', cursive"
                      data-period="2000"
                      data-type='[ "Manage", "Organize", "Measure", "Grow","Attract"	 ]'
                    >
                      <span class="wrap"></span>
                    </span>
                    <span class="talent"> TALENT</span>
                  </h2>
                  <p class="description">
                    Create personalized career journeys for talent development.
                    Simply put, you can use GetBoarded to take people from Point
                    A in their career, to Point B, while providing necessary
                    resources on the journey.
                  </p>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1/2 z-index-9999">
              <!-- <lets-login /> -->
              <img
                data-v-7aedf0b4=""
                width="100%"
                :src="require('@/assets/images/pages/home/img-org.png')"
                alt=""
                style="z-index: 99999; margin: 0px 0px"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="login-ends smooth-scroll">
      <div style="position: relative">
        <back-to-top
          ><vs-button
            class="backToTop"
            color="primary"
            type="filled"
            icon="arrow_upward"
          ></vs-button
        ></back-to-top>
      </div>
      <down-section />
    </div>
  </div>
</template>

<script>
import constants from "@/constants";
import BackToTop from "vue-backtotop";
import "./typewriter";
import LetsLogin from "./LetsLogin.vue";
import DownSection from "./DownSection.vue";
// import ProfileDropDown from "@/layouts/components/user-dashboard/navbar/components/UserProfileDropDown.vue";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
// import { Label } from "@amcharts/amcharts4/core";
gsap.registerPlugin(ScrollTrigger);

export default {
  ScrollTrigger,
  components: { LetsLogin, DownSection, BackToTop },
  data() {
    return {
      constants,
    };
  },
  computed: {
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
  },

  mounted() {
    // Color Follows Mouse Pointer
    let element = document.querySelector("body");
    element.style.setProperty("--x", "100 px");
    element.style.setProperty("--y", "100 px");
    element.addEventListener("mousemove", (e) => {
      // let rect = e.target.getBoundingClientRect();
      let x = e.clientX;
      let y = e.clientY;
      element.style.setProperty("--x", x + "px");
      element.style.setProperty("--y", y + "px");
    });

    this.panelEffect = ScrollTrigger.matchMedia({
      "(min-width: 992px)": function () {
        gsap.utils.toArray(".panel").forEach((panel) => {
          ScrollTrigger.create({
            trigger: panel,
            start: "top top",
            end: "bottom top",
            pin: true,
            pinSpacing: false,
            snap: 1,
          });
        });
      },
    });

    gsap.to(".secondary-menu-wrapper", {
      opacity: 0,
      scrollTrigger: {
        trigger: ".login-ends",
        start: 4800,
        toggleActions: "play pause pause reverse",
      },
    });

    ScrollTrigger.matchMedia({
      "(min-width: 150px)": function () {
        gsap.to("#myHeader", {
          opacity: 0,
          scrollTrigger: {
            trigger: ".login-ends",
            start: "top top",
            toggleActions: "play pause pause reverse",
          },
        });
      },
    });

    let t1 = gsap.timeline({
      scrollTrigger: {
        trigger: ".third",
        start: "top center",
        end: "bottom bottom",
        scrub: true,
      },
    });
    t1.to(".for", { y: 27, duration: 1 }, "a");
    t1.to(".ind", { opacity: 1, duration: 1 }, "a");
    t1.to(".org", { opacity: 0.3, duration: 1 }, "a");

    let t2 = gsap.timeline({
      scrollTrigger: {
        trigger: ".login-ends",
        start: "top center",
        end: +500,
        scrub: true,
      },
    });
    t2.to(".for", { y: 55, duration: 5 }, "b");
    t2.to(".ind", { opacity: 0.3, duration: 1 }, "b");
    t2.to(".evr", { opacity: 1, duration: 1 }, "b");
  },
  beforeDestroy() {
    this.panelEffect.kill();
  },
};
</script>

<style scoped>
.backToTop {
  position: absolute;
  z-index: 5100;
  bottom: 60px;
  right: 0;
}
.nav-login {
  z-index: 99999;
  position: fixed;
  right: 0;
}
#sign-in {
  background-color: #f2c244;
  border-radius: 20px;
  padding: 5px 16px 6px 17px;
  letter-spacing: 2px;
}

.gtb-color {
  background-color: #f2c244;
}
.secondary-menu-wrapper {
  padding-top: calc(90.57143px + 20.96639vw);
  z-index: 3;
  position: fixed;
  left: -20px;
}
.paragraph-small {
  color: #798ba0;
}

.ind {
  opacity: 0.3;
}
.evr {
  opacity: 0.3;
}
/** Background Color Follows Mouse Pointer */

.mouse-cursor-gradient-tracking::before {
  --size: 100vw;
  content: "";
  position: absolute;
  left: var(--x);
  top: var(--y);
  width: var(--size);
  height: var(--size);
  background: radial-gradient(
    circle closest-side,
    rgba(247, 179, 97, 0.3),
    transparent
  );
  transform: translate(-50%, -50%);
  transition: width 0.2s ease, height 0.2s ease;
  z-index: -999;
}

.mouse-cursor-gradient-tracking:hover:before {
  --size: 100vw;
}

/** Background Color Follows Mouse Pointer */

.parent {
  width: 100%;
  height: 100%;
}

.panel {
  height: 100ch;
}
.third {
  top: 0;
  background-color: #ffffff;
  box-shadow: 0 -20px 40px 0 rgb(150 174 195 / 15%);
  /* max-height: 700px!important; */
  /* max-height: 60vw!important; */
}
.first {
  top: 0;
  padding-top: 15vw;
  /* height: 47.5vw; */
  background-image: url("../../assets/images/pages/home/Individuals.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.bg-individual {
  padding-top: 15vw;
  padding-bottom: 14vw;
  background-image: url("../../assets/images/pages/home/Organization.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.title {
  position: relative;
  text-align: left;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 62px;
  color: #30384b;
}
.talent {
  position: absolute;
  color: #f2c244;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
}
.description {
  text-align: left;
  font-weight: normal;
  font-size: 18px;
  line-height: 32px;
  letter-spacing: -0.01em;
  color: #798ba0;
}

body {
  overflow-y: hidden !important;
}

.z-index-9999 {
  z-index: 9999;
}
.login-ends {
  margin-top: 60vw;
  background-color: white;
}
#myHeader {
  position: fixed;
}
.abs {
  position: absolute !important;
}

@media screen and (max-width: 1200px) {
  .talent {
    right: -10%;
  }

  aside {
    display: none;
  }

  .mouse-cursor-gradient-tracking:hover:before {
    --size: 30vw;
  }
  .mouse-cursor-gradient-tracking::before {
    --size: 30vw;
  }
}
@media screen and (max-width: 950px) {
  .talent {
    /*right: 37%;*/
  }
}
@media screen and (max-width: 589px) {
  .first {
    padding-top: 40vw;
  }
  .panel {
    height: 90ch;
  }
  .third {
    background-color: transparent;
    box-shadow: none;
  }
  .login-ends {
    margin-top: 0;
  }
  .title {
    font-size: 24px;
    line-height: 36px;
  }
  .talent {
    right: 20%;
  }
  .description {
    font-size: 16px;
    line-height: 26px;
  }
  #myHeader img {
    width: 60%;
    padding-top: 10px;
  }
}
</style>
